var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectricity = function SvgElectricity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#electricity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m6.471 10.32 9.666-7.552c.168-.132.398.057.301.248l-3.612 7.116a.2.2 0 0 0 .105.277l5.05 1.99a.2.2 0 0 1 .05.344L7.14 21.157c-.172.133-.402-.064-.298-.254l4.428-8.125a.2.2 0 0 0-.103-.282L6.52 10.665a.2.2 0 0 1-.05-.344Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "electricity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h20v20H2z"
  })))));
};
export default SvgElectricity;